/* unplugin-vue-components disabled */import { render } from "./ContainerAside.vue?vue&type=template&id=fef46eea"
import script from "./ContainerAside.vue?vue&type=script&lang=js"
export * from "./ContainerAside.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__